// This file is auto-generated by the build system.
const meta = {
  version: '0.7.5',
  date: '2025-12-13T06:52:47.408Z',
};
export default meta;
